/// <amd-module name="Test/ManualTestReports/TestReportsCommon/BaseWidgetComponent" />
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ITestProgressReportWidgetProps } from "Test/ManualTestReports/TestReportsCommon/ITestProgressReportWidgetProps";

export abstract class BaseWidgetComponent<P extends ITestProgressReportWidgetProps = ITestProgressReportWidgetProps, S = {}, SS = {}> extends VssComponent<P, S, SS> {

    private _isDataAvailable: boolean = false;
    
    constructor(props: P, context?: IVssComponentContext) {
        super(props, context);
        this.props.onRenderingStart(this.props.widgetName);
    }

    public logRenderingStart(): void{
        if (this._isDataAvailable && this.isLoading()) {
            this.props.onRenderingStart(this.props.widgetName);
            this._isDataAvailable = false;
        }
    }

    public componentDidMount(): void {
        super.componentDidMount();
        this._logRenderingEnd();
    }

    public componentDidUpdate(prevProps: P, prevState: S): void {
        super.componentDidUpdate(prevProps, prevState);
        this._logRenderingEnd();
    }

    protected abstract isLoading(): boolean;

    private _logRenderingEnd() {
        if (!this._isDataAvailable && !this.isLoading()) {
            this.props.onRenderingEnd(this.props.widgetName);
            this._isDataAvailable = true;
        }
    }
}
